"use strict";

var CodeType;
Object.defineProperty(exports, "__esModule", {
  value: !0
}), function (e) {
  e.Axel = "Axel", e.AxelZip = "AxelZip", e.AxelZipShort = "AxelZipShort", e.Displacement = "Displacement", e.DisplacementKey = "DisplacementKey", e.Tick = "Tick", e.Pack = "Pack", e.Tornado = "Tornado", e.DisplacementZip = "DisplacementZip", e.DisplacementZipShort = "DisplacementZipShort";
}(CodeType = exports.CodeType || (exports.CodeType = {}));